import { useRef, useEffect } from 'react';
import { useVesselContext, Vessel } from '../contexts/VesselContext';
import { baseApiUrl } from '../constants/Api';
import { apiKey } from '../constants/Api';
import { vesselsName } from '../constants/Vessel'
import dayjs from 'dayjs';
export function useVesselPositions() {
    const { vessels, setVessels, vesselsPositionDataTimeRange, setVesselsPositionDataTimeRange, setCurrentPositionDataRange } = useVesselContext();
    const getPositionsQueue = useRef(Promise.resolve());
    // Ref để luôn giữ vessels mới nhất
    const vesselsRef = useRef(vessels);
    const vesselsPositionDataTimeRangeRef = useRef(vesselsPositionDataTimeRange);
    useEffect(() => {
        // Cập nhật cả hai ref khi vessels hoặc timeRange thay đổi
        vesselsRef.current = vessels;
        vesselsPositionDataTimeRangeRef.current = vesselsPositionDataTimeRange;
    }, [vessels, vesselsPositionDataTimeRange]);
    // Hàm lấy dữ liệu vị trí tàu (tương tự getPositions)
    const getPositions = async (from?: number, to?: number, unitid?: string) => {
        to = to ?? Date.now();
        from = from ?? dayjs().subtract(1, 'day').startOf('day').valueOf();
        if (!unitid) {
            try {
                const currentVessels = vesselsRef.current;
                if (currentVessels != null && Object.keys(currentVessels).length != 0) {
                    //quản lý dữ liệu khi đã có dữ liệu
                    var getDataFrom: number = from, getDataTo: number = to, indexDataRange = -1, newVesselsDataTimeRange: [number, number][] = [], inserted = false;
                    if (getDataFrom-1 > vesselsPositionDataTimeRangeRef.current.at(-1)?.[1]!) {
                        newVesselsDataTimeRange = [...vesselsPositionDataTimeRangeRef.current, [from, to]];
                    }
                    else if (getDataTo+1 < vesselsPositionDataTimeRangeRef.current.at(0)?.[0]!) {
                        newVesselsDataTimeRange = [[from, to], ...vesselsPositionDataTimeRangeRef.current];
                    }
                    else if (vesselsPositionDataTimeRangeRef.current.filter(x => x[0] <= from! && x[1] >= to!).length > 0) {
                        newVesselsDataTimeRange = vesselsPositionDataTimeRangeRef.current;
                        getDataFrom = -1;
                        getDataTo = -1;
                    }
                    else {
                        let startIndex = vesselsPositionDataTimeRangeRef.current.findIndex((x: [number, number]) => x[1] >= from! - 1);
                        let endIndex = vesselsPositionDataTimeRangeRef.current.reverse().findIndex((x: [number, number]) => x[0] <= to! + 1);
                        if (startIndex > endIndex) {
                            newVesselsDataTimeRange = [...vesselsPositionDataTimeRangeRef.current];
                            newVesselsDataTimeRange.splice(startIndex, 0, [from, to]);
                        } else {
                            //lấy các đoạn thời gian bị giao cắt
                            let tempRanges = vesselsPositionDataTimeRangeRef.current.slice(startIndex, endIndex + 1);
                            tempRanges.forEach(range => {
                                //tìm khoảng thời gian chưa có data (chưa có trong các khoảng cũ)
                                if (from! >= range[0]) getDataFrom = range[1] + 1;
                                if (to! <= range[1]) getDataTo = range[0] - 1;
                                from = Math.min(from!, range[0]);
                                to = Math.max(to!, range[1]);
                            });
                            //xây dựng mảng mới
                            newVesselsDataTimeRange = vesselsPositionDataTimeRangeRef.current.slice(0, startIndex);
                            newVesselsDataTimeRange.push([from, to]);
                            newVesselsDataTimeRange = newVesselsDataTimeRange.concat(vesselsPositionDataTimeRangeRef.current.slice(endIndex + 1));
                        }

                    }
                    if (getDataFrom != -1 && getDataTo != -1) {
                        vesselsPositionDataTimeRangeRef.current = newVesselsDataTimeRange;
                        console.log("Updated vesselsPositionDataTimeRangeRef:", vesselsPositionDataTimeRangeRef.current);
                        setVesselsPositionDataTimeRange(newVesselsDataTimeRange);
                        //api
                        const res = await fetch(`${baseApiUrl}position?from=${getDataFrom}&to=${getDataTo}`, {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                "x-api-key": apiKey["x-api-key"],
                            },
                        });
                        const data = await res.json();
                        var temp: Record<string, { positions: any[] }> = {};
                        //duyệt lấy mảng data mới
                        data["position"].forEach((element: any) => {
                            const unitid = element.unitid;
                            if (temp[unitid]) {
                                temp[unitid].positions.push(element);
                            } else {
                                temp[unitid] = {
                                    positions: [element],
                                }
                            }
                        });
                        if (temp && Object.keys(temp).length != 0) {
                            //duyệt từng tàu trong temp để thêm data mới vào
                            let newVessels = { ...currentVessels };
                            Object.keys(temp).forEach(unitid => {
                                if (!newVessels[unitid]) {
                                    //tạo mới nếu chưa có
                                    var name = Object.values(vesselsName).find(x => x.unitId == unitid)?.name;
                                    if (!name) name = "#";
                                    newVessels[unitid] = {
                                        vesselName: name,
                                        positions: [],
                                        unitId: unitid,
                                        contactNumber: null,
                                        leafletMarker: null,
                                        windyMarker: null,
                                    }
                                }
                                let fromIndex = getDataFrom
                                    ? newVessels[unitid].positions.findIndex(x => x.arrivedtime >= getDataFrom)
                                    : -1;
                                if (fromIndex < 0) {
                                    //toàn bộ data mới nằm sau data cũ
                                    newVessels[unitid].positions.push(...temp[unitid].positions);
                                } else {
                                    //data mới nằm giao nhau hoặc trước data cũ
                                    let toIndex = newVessels[unitid].positions.findIndex(x => x.arrivedtime > getDataTo);
                                    if (toIndex < 0) toIndex = newVessels[unitid].positions.length;
                                    newVessels[unitid].positions.splice(fromIndex, toIndex - fromIndex, ...temp[unitid].positions);
                                }
                            });
                            setVessels(newVessels);
                        }
                    }
                } else {
                    //khởi tạo dữ liệu
                    vesselsPositionDataTimeRangeRef.current = [[from, to]];
                    setVesselsPositionDataTimeRange([[from, to]]);
                    setCurrentPositionDataRange([from, to]);
                    const res = await fetch(`${baseApiUrl}position?from=${from}&to=${to}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "x-api-key": apiKey["x-api-key"],
                        },
                    });
                    const data = await res.json();
                    let newVessels = { ...currentVessels };
                    data["position"].forEach((element: any) => {
                        if (newVessels[element.unitid]) {
                            newVessels[element.unitid].positions.push(element);
                        } else {
                            var name = Object.values(vesselsName).find(x => x.unitId == element.unitid)?.name;
                            if (!name) name = "#";
                            newVessels[element.unitid] = {
                                vesselName: name,
                                positions: [element],
                                unitId: element.unitid,
                                contactNumber: null,
                                leafletMarker: null,
                                windyMarker: null,
                            }
                        }
                    });
                    setVessels(newVessels);
                }

            } catch (err) {
                console.log(err);
            }
        }
    };

    // Hàm lấy dữ liệu theo hàng đợi (tương tự getPositionsQueued)
    const getPositionsQueued = (from?: number, to?: number, unitid?: string) => {
        getPositionsQueue.current = getPositionsQueue.current.then(() => getPositions(from, to, unitid)).catch(console.error);
        return getPositionsQueue.current;
    };

    return { getPositions, getPositionsQueued };
}